<template>
  <div class="all">
<div class="main">

    <div class="header">
        <div class="header-center fl">
            <div class="header-title">
              {{unitName}}产权竞价系统
            </div>
            <div class="header-img"></div>
        </div>
        <div class="header-bottom fl"></div>

    </div>

    <div class="content">
        <div class="content-left">
            <!--<img src="images/d.png" alt="">-->
        </div>
        <div class="content-right">
            <div class="right-infp">
                <div class="right-infp-name">

                    <input type="text" name="username" v-model="loginForm.phone" placeholder="请输入手机号" maxlength="12" required="" value="" autocomplete="off">
                </div>
                <div class="right-infp-name">
                    <input type="password" name="name"  v-model="loginForm.password"  placeholder="请输入密码" autocomplete="off">
                </div>
                <div class="right-infp-name"  style="width: 130px;float: left;" >
                    <input type="text"  v-model="loginForm.verifyCode"  placeholder="请输入验证码" autocomplete="off"   @keyup.enter="login">
                </div>
                <img width="100px" height="38px" style="margin-left: 2px;"  @click="getCaptcha()" :src="
                  'http://36.133.43.44:8547/api/web/captcha?uuid=' +
                  this.loginForm.uuid
                " />

                <div class="right-infp-btn" style="margin-top:16px;">
                    <button class="btn" @click="login()" >登录</button>
                </div>
                <div class="right-infp-btn1" style="margin-top:5px;">
                    <button class="btn" @click="register()" >注册</button>
                </div>
            </div>
        </div>
    </div>

</div>
</div>

</template>

<script>
  import $ from 'jquery';
  window.jQuery = $;
  window.$ = $;
 $(document).ready(function () {
      var whei = $(window).width()
      $("html").css({ fontSize: whei / 24 });

      $(window).resize(function () {
          var whei = $(window).width();

          $("html").css({ fontSize: whei / 24 })
      });
  });
  export default {
    data() {
      return {
        unitName: localStorage.getItem("unitName"),
        
        textType: 'password',
        loginForm: {
          phone: "",
          password: "",
          verifyCode: "",
          uuid: "",
        },
        captchaPath: "",
      }
    },
    created() {

      this.getCaptcha();


    },
    mounted() {
      window.addEventListener('login',this.login);
    },
    methods: {
      // 登录
      login() {
        this.$http.post("/web/login", this.loginForm).then((res) => {
          console.log(res);

          if (res.data.msg =="success") {
              localStorage.setItem("token", res.data.data.token);
              localStorage.setItem("userId", res.data.data.userId);
              localStorage.setItem("phone", this.loginForm.phone);
               localStorage.setItem("name", res.data.data.name);
                 localStorage.setItem("isExit","1");
              this.$router.push("/enrollProjectAlready");
          } else {
            this.$message.error("用户名和密码不匹配，请重新输入！");
            this.getCaptcha();
            return null;
          }

        });
      },
      async getCaptcha() {
        this.loginForm.uuid = Date.parse(new Date());
      },changeType () {
        this.textType = (this.textType === 'password' ? 'text' : 'password')
      },
      register(){

        this.$router.push("/register")
      },
    },
  }
</script>

<style lang="css" scoped>
input:-webkit-autofill {
  -webkit-text-fill-color: #fff;
  transition: background-color 50000s ease-in-out 0s;
}

  *{
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box}
  *,body{padding:0px;	margin:0px;color: #ffffff;/*font-family: "微软雅黑";*/}
  .all{
      background: url("../assets/loginImgs/bj.jpg") no-repeat;
      background-size: cover;
      font-size: .16rem;
      color: #ffffff;
      position: relative;
      width: 100%;
      height: 100%;
  }
  .main{
      margin: 0 auto;
      width: 100%;
      height: 100%;
      position: relative;
      background: url("../assets/loginImgs/bj.jpg") no-repeat;
      background-size: cover;
      font-size: .16rem;
      color: #ffffff;
      position: relative;
  }

  /*头部*/
  .header{
      width: 100%;
      height: 1.5rem;
      /*background: red;*/

  }

  .header .header-center{
      width: 50%;
      height: 1.2rem;
      position: relative;
      margin: 0 auto;
      margin-left: 25%;
  }
  .header .header-center .header-title{
      text-align: center;
      color: #ffffff;
      font-size: .4rem;
      text-shadow: 0 0 .3rem #00d8ff;
      line-height: 1.05rem;
  }
  .header .header-img{
      background: url("../assets/loginImgs/head.gif") no-repeat center center;
      background-size: 100%;
      height: 100%;
      width: 100%;
      position: absolute;
      top: .8rem;
  }

  .content{
      width: 12rem;
      height: 7rem;
      /*background: green;*/
      margin: 1rem auto 0 auto;
      /*border: 1px solid green;*/
  }
  .content .content-left{
      width:6.2rem ;
      height: 5.8rem;
      /*border: 1px solid red;*/
      background: url("../assets/loginImgs/d.png") no-repeat;
      background-size: 100% 100%;
      padding: 0.4rem 0;
      box-sizing: border-box;
      margin-right: 2%;
      float: left;
  }
  @-webkit-keyframes rotation {
      from {
          -webkit-transform: rotate(0deg);
      }
      to {
          -webkit-transform: rotate(360deg);
      }
  }

  .content .content-left {
      -webkit-transform: rotate(360deg);
      animation: rotation 15s linear infinite;
      -moz-animation: rotation 15s linear infinite;
      -webkit-animation: rotation 15s linear infinite;
      -o-animation: rotation 15s linear infinite;
  }

  .content .content-right{
      width:5.4rem ;
      height: 6.4rem;
      background: url("../assets/loginImgs/e.png") no-repeat;
      background-size: 100% 100%;
      float: right;
      position: relative;

  }
  .right-infp{
      width: 4rem;
      height: 3rem;
      margin: auto auto;
     /* border: 1px solid red;*/
      vertical-align: center;
      position: absolute;
      top:1.6rem;
      left: 0.9rem;
  }
  .right-infp-name{
      background: url("../assets/loginImgs/b.png") no-repeat;
      width: 100%;
      height: 40px;
      background-size: 100% 100%;
      line-height:0.45rem;
      margin-bottom: 0.2rem;
      position: relative;
  }
  .right-infp-name input{
      width: 85%;
      border: none;
      box-sizing: border-box;
      height: 40px;
      margin-left: 19px;
      line-height: 0.4rem;
      background: none !important;
      color: #00eaff;
      padding-left: 0.15rem;
      /*box-shadow: 0 0 1px #00eaff;*/
      outline: none;
      -webkit-tap-highlight-color:rgba(255,0,0,0);
      position: absolute;


  }
  input::-webkit-input-placeholder {
      color: #ccc;
  }
  .right-infp-btn{
      background: url("../assets/loginImgs/a.png") no-repeat;
      width: 100%;
      height: 0.5rem;
      background-size: 100% 100%;
      line-height: 0.5rem;
      margin-bottom: 0.4rem;
      position: relative;
  }
  .right-infp-btn1{

      width: 100%;
      height: 0.5rem;
      background-size: 100% 100%;
      line-height: 0.5rem;
      margin-bottom: 0.4rem;
      position: relative;
  }
  .right-infp-btn1 .btn{
  background-color:#086372;
    border:1px solid #086372;
      width: 100%;
      height: 0.5rem;
      background-size: 100% 100%;
      line-height: 0.5rem;
      margin-bottom: 0.4rem;
      position: relative;
  }
  .right-infp-btn .btn{
      width: 95%;
      border: none;
      box-sizing: border-box;
      height: 0.45rem;
      margin-left: 0.1rem;
      font-size: 0.22rem;
      cursor: pointer;
      background: none;
      outline: none;
      color: #fff;
      position: absolute;


  }
  .right-infp-btn .btn:hover{

  }
</style>
